import type { ReactNode } from 'react';

export const symbol_view_object_track: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M291-160q-55 0-93-39.55t-38-95.5q0-55.95 38-95.45t93-39.5h458q55 0 93 39.55t38 95.5q0 55.95-38 95.45T749-160H291Zm0-60h458q29.58 0 50.29-21.82 20.71-21.83 20.71-53Q820-326 799.29-348T749-370H291q-29.58 0-50.29 21.82-20.71 21.83-20.71 53Q220-264 240.71-242T291-220Zm-80-310q-55 0-93-39.55t-38-95.5q0-55.95 38-95.45t93-39.5h458q55 0 93 39.55t38 95.5q0 55.95-38 95.45T669-530H211Zm0-60h458q29.58 0 50.29-21.82 20.71-21.83 20.71-53Q740-696 719.29-718T669-740H211q-29.58 0-50.29 21.82-20.71 21.83-20.71 53Q140-634 160.71-612T211-590Zm309 295Zm-80-370Z"
		/>
	</svg>
);
